import React from 'react';
import FilterComponents from '../FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';

function AddRecommendation(props) {
    const columns = [
        {
            field: 'checkbox',
            headerName: 'Checkbox',
            renderCell: () => <input type="checkbox" />,
        },
        { field: 'recommendedItem', headerName: 'Recommended Item', width: 200 },
        { field: 'Timeduration', headerName: 'Time Duration', width: 200 }
    ];

    const dataRows = [
        { id: 1, checkbox: '', recommendedItem: 'Chicken cheese burger', Timeduration: "10:00 AM-10:00 PM" },
        { id: 2, checkbox: '', recommendedItem: 'Chicken Pizza', Timeduration: "10:00 AM-10:00 PM" },
    ];
    return (
        <div>
            <div>
                <FilterComponents title={"OK"} isItem={5} />
                <CustomDataGrid columns={columns} dataRows={dataRows} />
            </div>
        </div>
    );
}

export default AddRecommendation;